import HelpIndex from './HelpIndex';
import HelpCreate from './HelpCreate';
import HelpSettings from './HelpSettings';
import HelpSingle from './HelpSingle';

export default function (app) {

    const settings = HelpSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            }
        ],
    });

    HelpIndex(app, settings);

    HelpCreate(app, settings);

    HelpSingle(app, settings);

}